const LFSConstants = {
	LFS_PATH : '/land-for-sale',
	STATES : ['','available','sold','hold','deposit','builders exclusive'],
	STATE_CLASSES : ['','available','sold','hold','deposit','buildersexclusive'],
	ACTIVE_STATES : [1],
	DISPLAY_STATES : [2,3,4],
}

export default LFSConstants;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/LFSConstants.js
 **/